import React, { useState, createContext, useContext } from "react";
import { Confirmation } from '@components'
import { useTranslation } from 'react-i18next';

const AppContext = createContext({});

const AppContextProvider = ({ children }) => {

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogConfig, setDialogConfig] = useState({});

  const openDialog = ({ title, message, actionCallback }) => {
    setDialogOpen(true);
    setDialogConfig({ title, message, actionCallback });
  };

  const resetDialog = () => setDialogOpen(false)

  const onConfirm = () => {
    resetDialog();
    dialogConfig.actionCallback(true);
  };

  const onDismiss = () => {
    resetDialog();
    dialogConfig.actionCallback(false);
  };

  return (
    <AppContext.Provider value={{ openDialog }}>
      <Confirmation
          open={dialogOpen}
          onDismiss={onDismiss}
          title={dialogConfig?.title}
          message={dialogConfig?.message}
          onConfirm={onConfirm}
        />
      {children}
    </AppContext.Provider>
  );
};

// for confirmation
const useConfirmationDialog = () => {
  const { openDialog } = useContext(AppContext);

  const getConfirmation = ({ ...options }) =>
    new Promise((resolve) => {
      openDialog({ actionCallback: resolve, ...options });
    });

  return { getConfirmation };
};

export { AppContextProvider, useConfirmationDialog, useTranslation};
